import { NavLink } from "react-router-dom";
import { UserButton } from "@clerk/react";
import { Logo } from "@/components/Logo";
import { useMe } from "@/lib/api";

const linkCls = ({ isActive }) =>
  `text-sm font-medium transition-colors ${isActive ? "text-thread" : "text-ink-soft hover:text-ink"}`;

export const AppHeader = ({ children }) => {
  const me = useMe();
  return (
    <header className="sticky top-0 z-30 border-b border-paper-border bg-paper/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-[1500px] items-center gap-6 px-4 sm:px-6">
        <Logo to="/app" size={30} />
        <nav className="flex items-center gap-5">
          <NavLink to="/app" end className={(s) => `hidden sm:inline ${linkCls(s)}`} data-testid="nav-documents">My documents</NavLink>
          <NavLink to="/invoices" className={linkCls} data-testid="nav-invoices">Invoices</NavLink>
          {me?.role === "admin" && <NavLink to="/admin" className={linkCls} data-testid="nav-admin">Admin</NavLink>}
        </nav>
        <div className="ml-auto flex items-center gap-3">
          {children}
          <div data-testid="user-menu"><UserButton /></div>
        </div>
      </div>
    </header>
  );
};
